
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabandbusserviceinphugewadi() {



const cardData = {
  keyword: 'Corporate Cab and Bus Services in Phugewadi',
  heading: 'eTravo: Corporate Cab and Bus Services in Phugewadi',
  headingDescription: `eTravo delivers reliable and tailored corporate cab and bus services in Phugewadi, a vital industrial and residential area in Pune located near major business zones like Bhosari, Nashik Phata, and Pimpri-Chinchwad. Our services are designed to meet the daily transportation needs of companies, IT offices, warehouses, and commercial centers operating in and around Phugewadi.`,

  top: 'Top Places to visit in Pune with eTravo',
"topPlaces": [
  {
    "title": "Khed City Industrial Park",
    "description": "Khed City is a 4,200-acre integrated industrial township developed by the Kalyani Group and MIDC. It hosts global and Indian companies like Mars International, Maxion Wheels, Amul, and Hyosung. eTravo provides tailored employee transportation solutions, ensuring efficient and timely commutes within this expansive industrial zone."
  },
  {
    "title": "Rajgurunagar (formerly Khed) Town Center",
    "description": "Rajgurunagar serves as the administrative headquarters of Khed Taluka. With its strategic location on the Pune-Nashik Highway, it is a hub for commerce and governance. eTravo offers reliable cab services for residents, officials, and visitors, facilitating smooth travel within and beyond the town."
  },
  {
    "title": "Hutatma Rajguru Mahavidyalaya",
    "description": "This prominent educational institution offers undergraduate and postgraduate programs in Arts, Commerce, and Science. eTravo ensures safe and punctual transportation for students and faculty, supporting academic pursuits in the region."
  },
  {
    "title": "Sahyadri School (Krishnamurti Foundation India)",
    "description": "Located near Tiwai Hill, Sahyadri School provides holistic education amidst nature. eTravo caters to the transportation needs of students and staff, ensuring comfortable travel to this serene campus."
  },
  {
    "title": "Dilawar Khan's Tomb and Mosque",
    "description": "A 17th-century Mughal-era monument, this site is a testament to the region's rich history. eTravo offers guided tour transportation services, allowing history enthusiasts to explore this architectural marvel conveniently."
  },
  {
    "title": "Khed Railway Station",
    "description": "Situated on the Konkan Railway line, Khed Railway Station connects the town to major cities. eTravo provides seamless first and last-mile connectivity, ensuring travelers reach their destinations on time."
  },
  {
    "title": "Chas-Kaman Dam",
    "description": "A vital water reservoir near Khed, it supports irrigation and water supply in the region. eTravo facilitates visits for professionals and tourists interested in environmental and infrastructural studies."
  },
  {
    "title": "Government ITI Khed",
    "description": "This Industrial Training Institute offers vocational courses, enhancing skill development in the area. eTravo supports students with dependable transportation options, aiding in their educational journey."
  },
  {
    "title": "Khed Bus Stand",
    "description": "A central hub for road transport, connecting Khed to various parts of Maharashtra. eTravo complements public transport by offering flexible cab services for travelers and daily commuters."
  },
  {
    "title": "Local Markets and Commercial Areas",
    "description": "Khed's bustling markets are centers of trade and daily life. eTravo provides convenient transportation for shoppers and business owners, ensuring easy access to these commercial zones."
  }
],

services: [
  {
    name: 'Phugewadi Corporate Travel Services',
    description: `Comprehensive corporate travel solutions for businesses in Phugewadi. Our monthly packages ensure reliable employee and executive transport with flexible scheduling and professional drivers.`
  },
  {
    name: 'Employee Shuttle Services in Phugewadi',
    description: `Efficient employee shuttle services designed for daily commutes in Phugewadi. Includes fixed and customizable routes with safe, punctual transportation options for all shift timings.`
  },
  {
    name: 'Cab & Bus Rentals for Businesses Phugewadi',
    description: `Monthly cab and bus rental services tailored to the needs of businesses in Phugewadi. Offers a fleet of AC and non-AC vehicles, with GPS tracking and courteous chauffeurs for smooth operations.`
  },
  {
    name: 'Daily Staff Transport Solutions Phugewadi',
    description: `Daily staff transport plans in Phugewadi that cater to the commute needs of factory and office employees. Reliable, timely service with focus on comfort and safety.`
  },
  {
    name: 'Office Commute Cab & Bus Services Phugewadi',
    description: `Office commute transportation services in Phugewadi, providing dependable cab and bus options for staff travel. Monthly plans with route optimization and easy billing for corporate clients.`
  },
  {
    name: 'Affordable Corporate Rentals Phugewadi',
    description: `Cost-effective corporate vehicle rental solutions in Phugewadi. Ideal for startups and SMEs looking for budget-friendly employee commute options without compromising on quality.`
  }
],

tableData: [
  ['Phugewadi Corporate Travel Services', 'Employee Shuttle Services in Phugewadi'],
  ['Cab & Bus Rentals for Businesses Phugewadi', 'Daily Staff Transport Solutions Phugewadi'],
  ['Office Commute Cab & Bus Services Phugewadi', 'Affordable Corporate Rentals Phugewadi']
],




"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab and Bus Services in Phugewadi",
    "WhyChoosedescription": "eTravo delivers efficient and reliable corporate cab and bus services in Phugewadi, helping businesses ensure timely and comfortable daily commutes for their employees."
  },
  {
    "WhyChooseheading": "Extensive Fleet for Corporate and Industrial Needs",
    "WhyChoosedescription": "From sedans and SUVs for executive travel to high-capacity buses for workforce transport, our fleet is equipped to meet varied business mobility requirements in Phugewadi."
  },
  {
    "WhyChooseheading": "Flexible Shift-Based Transportation Services",
    "WhyChoosedescription": "Our services are designed to support multiple shift timings, making employee transportation efficient and aligned with your operational hours."
  },
  {
    "WhyChooseheading": "Local Drivers with Route Expertise in Phugewadi",
    "WhyChoosedescription": "Our experienced drivers are well-versed with Phugewadi’s roads and peak traffic hours, ensuring smooth, punctual, and safe rides every day."
  },
  {
    "WhyChooseheading": "GPS-Enabled Vehicles for Real-Time Tracking",
    "WhyChoosedescription": "All our vehicles are fitted with GPS tracking, allowing real-time monitoring and increased security for your employee transportation operations."
  },
  {
    "WhyChooseheading": "Clear Monthly Billing and Transparent Invoices",
    "WhyChoosedescription": "We offer detailed and itemized monthly invoices, enabling businesses to monitor transportation expenses and maintain financial clarity."
  },
  {
    "WhyChooseheading": "High Standards of Vehicle Hygiene and Safety",
    "WhyChoosedescription": "Our fleet is regularly cleaned and sanitized, with all safety protocols followed to ensure a clean and healthy environment for commuters."
  },
  {
    "WhyChooseheading": "Dedicated Account Manager for Seamless Coordination",
    "WhyChoosedescription": "A dedicated account manager handles all transport logistics for your company in Phugewadi, ensuring reliable service and quick issue resolution."
  }
]



















}

const faqData = [
  [
    {
      question: "Which areas do your corporate cab and bus services cover?",
      answer: "We offer corporate transportation services in Pune and surrounding industrial areas, including Phugewadi, Hadapsar, Kharadi, and nearby locations."
    },
    {
      question: "Can we customize transport plans based on employee shifts and workforce size?",
      answer: "Yes, we provide flexible transport solutions tailored to your company’s specific shift timings, employee count, and preferred routes."
    },
    {
      question: "Do you provide GST-compliant invoicing for corporate clients?",
      answer: "Absolutely. Our monthly billing includes consolidated GST-compliant invoices along with detailed trip and usage reports."
    },
    {
      question: "Are professional and verified drivers included in your services?",
      answer: "Yes, all drivers are background-verified, professionally trained, and experienced in corporate transportation."
    },
    {
      question: "What safety protocols are followed for employee transportation?",
      answer: "Our vehicles are GPS-enabled, sanitized regularly, and maintained to high safety standards. Driver verification and training are strictly enforced."
    },
    {
      question: "Is dedicated support available for managing daily transport operations?",
      answer: "Yes, we assign dedicated transport coordinators and provide live tracking tools to ensure smooth and efficient daily commute management."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Prashant More",
    designation: "Admin Manager, Phugewadi Industries",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s corporate cab and bus service in Phugewadi has made our employee commute safe, reliable, and hassle-free.”"
  },
  {
    name: "Ms. Smita Kulkarni",
    designation: "HR Head, Phoenix Technologies",
    rating: [1, 1, 1, 1, 1],
    text: "“The service provided by eTravo in Phugewadi is punctual, professional, and customized to our company’s transport needs.”"
  }
];























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab and Bus Services in Phugewadi",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bus-service-phugewadi.jpg",
  "description": "Book corporate cab and bus services in Phugewadi with eTravo for employee shuttle, daily staff transport, and office commute. Affordable and reliable AC cabs and buses tailored for businesses in Phugewadi.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5657"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2299",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-and-bus-services-in-phugewadi"
  }
};









    return (
        <div>
<Helmet>
  <title>Corporate Cab and Bus Services in Phugewadi | Staff Transport & Office Shuttle | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus services in Phugewadi with eTravo for employee shuttle, office commute, and business transport. Reliable and affordable AC cabs and buses for companies in Phugewadi." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/105.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabandbusserviceinphugewadi;